<template>

<div class="select" v-click-outside="onOutsideClick">

    <div class="select-text" v-on:click="onTextClick" v-tooltip="'Click to change'">
    
        <span>{{ text }}</span>

        <i class="select-icon fa fa-caret-down" :class="{'is-active': expanded}" />
    
    </div>

    <core-filter-advanced-builder-dropdown :options="optionsFinal" v-on:change="onChange" v-if="expanded" />

</div>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

    props: ['value', 'type', 'rule'],

    data: function() {

        return {
            model: '',
            expanded: false
        }

    },

    created: function() {

        this.model = this.value

    },

    computed: {

        text: function() {

            return this.type.options[this.model]

        },

        optionsFinal: function() {

            var options = []

            this.$_.each(this.type.options, function(text, value) {

                options.push({
                    value: value,
                    text: text
                })

            })

            return options

        }

    },

    watch: {

        value: function(n) {

            this.model = n

        },

        model: function(n) {

            this.$emit('input', n)

        }

    },

    methods: {
        
        onChange: function(value) {

            this.$emit('input', value)
            this.expanded = false

        },

        onOutsideClick: function() {

            this.expanded = false

        },

        onTextClick: function() {

            this.expanded = !this.expanded

        }

    }

}

</script>

<style scoped>

.select {
}

.select-text {
    padding: 0px 32px 0px 10px;
    line-height: 40px;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    border-radius: 4px;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.15);
}

.is-desktop .select-text:hover {
    background-color: rgba(0, 0, 0, 0.25);
}

.select-icon {
    position: absolute;
    right: 8px;
    top: 0px;
    font-size: 16px;
    width: 20px;
    text-align: center;
    line-height: 40px;
    color: rgba(255, 255, 255, 0.25);
}

.select-text:hover .select-icon.is-active {
    color: #fff;
}

</style>